import { useState, useEffect, useContext } from "react";
import DashboardLayout from "defaultComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "defaultComponents/Navbars/DashboardNavbar";
import { Grid, Card } from '@mui/material';
import VuiAvatar from "components/VuiAvatar";
import * as S from './style'
import { getAllInfluencers } from "utils/requests/auth";
import zePlaceholder from 'assets/ze.png'
import { SearchBarContext } from "context/SearchBarContext";
import { useDebounce } from "use-debounce";
import { getProfitGraphs } from "utils/requests/financial";
import PieChart from "defaultComponents/Charts/PieCharts/PieChart";

const Avatar = ({ img, theme, children, ...rest }) => (
  <VuiAvatar
    src={img}
    size="sm"
    {...rest}
    sx={({ borders: { borderWidth }, palette: { light }, functions: { rgba } }) => ({
      cursor: "pointer",
      position: "relative",
      "&:hover, &:focus": {
        zIndex: "10",
      },
    })}
  >
    {children}
  </VuiAvatar>
);

const pieChartOptions = {
  chart: {
    type: "donut",
  },
  labels: [],
  colors: [
    "#BE4E75",
    "#50859D",
    "#47C094",
    "#DB972C",
    "#744C75",
    "#5BADBF",
    "#92181C",
    "#545454",
  ],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: false,
  },
  tooltip: {
    y: {
      formatter: (val) => {
        return val + "%";
      },
      title: {
        formatter: (label) => {
          const splitLabel = label.split("(");
          return splitLabel[0];
        },
      },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: "bottom",
        },
      },
    },
  ],
}

const InfluencersWallets = () => {
  const [influencers, setInfluencers] = useState([]);
  const [businessProfitGraph, setBusinessProfitGraph] = useState({
    series: [],
    options: pieChartOptions,
  });
  const [brandProfitGraph, setBrandProfitGraph] = useState({
    series: [],
    options: pieChartOptions,
  });
  const [filters, setFilters] = useState({ name: null });

  const { searchQuery } = useContext(SearchBarContext);
  const [debouncedSearch] = useDebounce(searchQuery, 600);

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      name: debouncedSearch ? debouncedSearch.toUpperCase() : null
    }));
  }, [debouncedSearch]);

  const fetchInfluencers = async () => {
    const data = await getAllInfluencers();

    if (Array.isArray(data)) {
      setInfluencers(data[0]);
    } else {
      setInfluencers([]);
    }
  }

  const fetchGraphData = async () => {
    await getProfitGraphs().then((res) => {
      if (!res?.message) {
        setBusinessProfitGraph((prevGraph) => ({
          series: res?.businessEarningsPercentage?.data,
          options: {
            ...prevGraph.options,
            labels: res?.businessEarningsPercentage?.labels,
          },
        }));
        setBrandProfitGraph((prevGraph) => ({
          series: res?.brandEarningsPercentage?.data,
          options: {
            ...prevGraph.options,
            labels: res?.brandEarningsPercentage?.labels,
          },
        }));
      }
    });
  };

  useEffect(() => {
    fetchInfluencers();
  }, []);

  useEffect(() => {
    fetchGraphData();
  }, [])

  const filteredInfluencers = influencers.filter(influencer => {
    if (!filters.name) return true;

    return (
      (influencer.name && influencer.name.toUpperCase().includes(filters.name))
    );
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container flexDirection='column'>
        <Grid container item spacing={2}>
          <Grid item xs={12} md={6}>
            <Card sx={{ padding: 0 }}>
              <Grid
                item
                sx={{ paddingLeft: "30px", paddingBottom: "30px", paddingTop: "20px" }}
              >
                <p style={{ paddingLeft: "20px", paddingTop: "20px" }}>Lucro Geral por Empresa</p>
                <S.PieChartGrid item xl={11.5}>
                  <PieChart
                    key={businessProfitGraph.series}
                    pieChartData={businessProfitGraph.series}
                    pieChartOptions={businessProfitGraph.options}
                  />
                </S.PieChartGrid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ padding: 0 }}>
              <Grid
                item
                sx={{ paddingLeft: "30px", paddingBottom: "30px", paddingTop: "20px" }}
              >
                <p style={{ paddingLeft: "20px", paddingTop: "20px" }}>Lucro Geral por Marca</p>
                <S.PieChartGrid item xl={11.5}>
                  <PieChart
                    key={brandProfitGraph.series}
                    pieChartData={brandProfitGraph.series}
                    pieChartOptions={brandProfitGraph.options}
                  />
                </S.PieChartGrid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <Grid container item xs={12} md={12} lg={12} xl={12} mt='20px'>
          <Card sx={{ width: '100%', minHeight: '780px' }}>
            <Grid container flexDirection="column">
              <p style={{ color: '#FFFFFF', paddingLeft: "20px", paddingTop: "20px" }}>Selecione um influencer</p>
            </Grid>
            <Grid container flexDirection='column' mt='30px'>
              <Grid container>
                {filteredInfluencers.map((influencer) => (
                  <Grid container item flexDirection='column' xs={6} md={4} lg={3} xl={2} key={influencer?.username}>
                    <S.RouterLink to={`/influencers/${influencer.username}/financeiro`}>
                      <S.UsersPipelineGrid container item flexDirection='column'>
                        <Avatar size='xxl' img={influencer?.avatar ? influencer?.avatar : zePlaceholder} />
                        <p>{influencer?.name}</p>
                      </S.UsersPipelineGrid>
                    </S.RouterLink>
                  </Grid>
                ))
                }
              </Grid>
            </Grid>
          </Card>
        </Grid >
      </Grid>
    </DashboardLayout >
  )
}

export default InfluencersWallets